import { FC, useState, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { Typography, Stack } from '@mui/material';

import { TopActions } from '@modules/Programs/components/TopActions';
import { BackButton } from '../components/BackButton';
import { JourneyCalendar } from '../components/JourneyCalendar';
import { StepReview } from '../components/StepReview';
import { useEnrollments } from '../hooks/useEnrollments';


interface Props {
  enrollment: Programs.Enrollment;
}

export const JourneyReviewPartial: FC<Props> = ({ enrollment }) => {
  const navigate = useNavigate();
  const [selectedEntry, setSelectedEntry] = useState<Programs.StepEntry | null>(null);
  const { enrollments } = useEnrollments();

  const allStepEntries = useMemo(() => {
    return enrollments
      .filter(e => e.program.id === enrollment.program.id)
      .flatMap(e => e.stepEntries);
  }, [enrollments, enrollment.program.id]);

  const stepsById = useMemo(() => {
    const map: Record<number, Programs.ProgramStep> = {};
    enrollment.program.steps.forEach(step => {
      map[step.id] = step;
    });
    return map;
  }, [enrollment.program.steps]);

  const selectedStep = selectedEntry ? stepsById[selectedEntry.programStep] : null;

  if (selectedEntry && selectedStep) {
    return (
      <Stack spacing={3} position="relative">
        <TopActions>
          <BackButton
            onClick={() => setSelectedEntry(null)}
            sx={{ alignSelf: 'flex-start', textTransform: 'uppercase', letterSpacing: '0.1em' }}
          />
        </TopActions>
        <StepReview step={selectedStep} entry={selectedEntry}/>
      </Stack>
    );
  }

  return (
    <Stack spacing={4} position="relative">
      <TopActions>
        <BackButton
          onClick={() => navigate(`/programs/journey/${enrollment.id}/complete`, { replace: true })}
          sx={{ alignSelf: 'flex-start', textTransform: 'uppercase', letterSpacing: '0.1em' }}
        />
      </TopActions>

      <Typography variant="h4" fontSize={20} textAlign="center">
        My Journey
      </Typography>

      <JourneyCalendar
        program={enrollment.program}
        stepEntries={allStepEntries}
        onEntryClick={setSelectedEntry}
      />
    </Stack>
  );
};
